import props from './props'

export default {
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/components/kinsfolk/resources/index.js